export const cardStyles = {
  classic: 'classic',
  vufinder: 'vufinder',
  geoFiltered: 'geo_filtered',
  survey: 'survey',
  halfScreenVideo: 'half_screen_video',
  halfScreenVideoWithCta: 'half_screen_video_with_cta',
  vuPage: 'vupage',
  textReminder: 'text_reminder'
};

export const cardLoadMode = {
  standalone: 'standalone',
  iframe: 'iframe',
  preview: 'preview'
};
